import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import Box from './Box';
import Code from './Code';
import Wrapper from './Wrapper';

function Skew({ variant, rotation, axis = 'x' }) {
  const bigAxis = axis.toUpperCase();
  const transformString =
    variant === 'skew'
      ? `skew(${rotation}deg)`
      : `skew${bigAxis}(${rotation}deg)`;

  // React Spring doesn't properly handle the Skew axis
  // changing! So let's create two springs, and toggle which one we use.
  const xStyles = useSpring({
    transform: `skewX(${rotation}deg)`,
  });
  const yStyles = useSpring({
    transform: `skewY(${rotation}deg)`,
  });

  return (
    <Wrapper>
      <Box style={axis === 'x' ? xStyles : yStyles}>Hello World</Box>
      <Code>transform: {transformString};</Code>
    </Wrapper>
  );
}

export default Skew;
